/** Internal dependencies */
import { throttle } from '../../../../../assets/src/scripts/utilities';
import { setHeroSliderHeight } from './components/setHeroSliderHeight';
import { setAlertSize } from './components/setAlertSize';

if (document.readyState !== 'loading') {
    initWidget();
} else {
    window.addEventListener('DOMContentLoaded', () => {
        initWidget();
    });
}

function initWidget() {
    if (!window.Swiper) {
        return;
    }

    const sliders = document.querySelectorAll('.ct_slider');

    throttle('resize', 'optimizedResize');

    if (sliders) {
        // init possible header sliders once
        setHeroSliderHeight();
        // init possible alerts
        setAlertSize();

        sliders.forEach((slider) => {
            const sliderContainer = slider.querySelector('.swiper-container');

            if (!sliderContainer) {
                return;
            }

            const swiperConfig = {
                speed: 1500,
                slidesPerView: 'auto',
                keyboard: true,
                loop: true,
                autoHeight: false,
                autoplay: {
                    delay: 3500,
                    disableOnInteraction: true,
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.button-next',
                    prevEl: '.button-prev',
                },
            };

            if (window.lazyLoadInstance) {
                // set swiperConfig.on to an empty object if it is not defined yet
                swiperConfig.on = swiperConfig.on || {};
                // update our lazyload instance on swiper init event
                swiperConfig.on.init = () => {
                    window.lazyLoadInstance.update();
                };
            }

            if (slider.classList.contains('heroslider')) {
                window.addEventListener('optimizedResize', setHeroSliderHeight);

                if (slider.classList.contains('heroslider--alert')) {
                    window.addEventListener('optimizedResize', setAlertSize);
                }
            }

            // init swiper (swiper is available in the global scope)
            const swiper = new Swiper(sliderContainer, swiperConfig);

            // start autoplay
            swiper.autoplay.start();
        });
    }
}
